
import { defineComponent } from "vue";
import api, { SimsSignalList, SimsSignal, Correlation, RequestPaging, PageBounding, RequestSort }  from "../../api/backend-api";
import { getSkipParamForPage, getPageBounding } from "../../util/paginationHelpers";
import { getHumanDate } from "../../util/luxonDateHelpers"
import { AxiosError } from "axios";
import format from "xml-formatter";

interface State {
  msg: string;
  backendResponse: SimsSignalList;
  requestFilter: SimsSignal;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
  filterOptions: Record<string, unknown>;
}

export default defineComponent({
  name: "SimsSignal",
  mounted() {
    this.$nextTick(() => {
      this.getList();
    });
  },

  data: (): State => {
    const signal_list = { } as SimsSignalList;
    const signal_struct = { 
      CorrelationEvent: {} as Correlation
    } as SimsSignal;
    const paging_struct = { Limit: 20, Skip: 0, Options: [ 20, 50, 100 ] } as RequestPaging;
    const sort_struct = { Pattern: '-id' } as RequestSort;
    const filter_options = {
      'Conversion': [
        'pending',
        'failed',
        'success'
      ],
      'State': [
        'none',
        'ready',
        'sent',
        'closing',
        'failed'
      ],
    };
    return {
      msg: "Generated Sims Signals",
      backendResponse: signal_list,
      requestFilter: signal_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      filterOptions: filter_options,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDate,
    setPage(command: string|number) {
      this.requestPaging.Skip = getSkipParamForPage(command, this.requestPaging.Skip, this.requestPaging.Limit);
      this.getList();
    },
    clearFiltersAndRefresh() {
      const filter_struct = { } as SimsSignal;
      this.requestFilter = filter_struct;
      this.getList()
    },
    formatXml(xml: string): string {
      return format(xml, {collapseContent: true});
    },
    getList() {
      this.backendResponse = { } as SimsSignalList;
      const request_params = api.createRequestParams(this.requestFilter, this.requestPaging, this.requestSorting)
      api
        .getSimsSignalList(request_params)
        .then((response) => {
          this.backendResponse = response.data;
          this.pageBounds = this.getPageBounding(this.backendResponse.count, this.requestPaging.Limit, this.requestPaging.Skip)
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
